import Vue from 'vue'
import http from '@/utils/ajax'
import { VESSEL_INIT_LOADING, VESSEL_INIT_SUCCESS, VESSEL_INIT_FAIL, VESSEL_DETAILLIST, VESSEL_CLASSLIST, VESSEL_CONSTNLIST, VESSEL_ENGMAKELIST, VESSEL_ENGMODLIST, VESSEL_FLAGLIST, VESSEL_TYPELIST, VESSEL_SIDEMENU, VESSEL_VOYAGE_TABMENU } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  makeList: [],
  modelList: [],
  vesselList: [],
  sideMenu: [],
  voyage: {
    vslVoyageTabMenu: 0,
    vslVoyageDisplayVoyageReviewTab: false,
    vslVoyageVesNo: undefined
  }
}

const getters = {

}

const mutations = {
  [VESSEL_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [VESSEL_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [VESSEL_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [VESSEL_DETAILLIST](state, data) {
    Vue.set(state, 'vesselList', data)
  },
  [VESSEL_CLASSLIST](state, data) {
    Vue.set(state, 'classList', data)
  },
  [VESSEL_CONSTNLIST](state, data) {
    Vue.set(state, 'constnList', data)
  },
  [VESSEL_ENGMAKELIST](state, data) {
    Vue.set(state, 'engMakeList', data)
  },
  [VESSEL_ENGMODLIST](state, data) {
    Vue.set(state, 'engModList', data)
  },
  [VESSEL_FLAGLIST](state, data) {
    Vue.set(state, 'flagList', data)
  },
  [VESSEL_TYPELIST](state, data) {
    Vue.set(state, 'typeList', data)
  },
  [VESSEL_SIDEMENU](state, data) {
    state.sideMenu = data
  },
  [VESSEL_VOYAGE_TABMENU](state, data) {
    state.voyage.vslVoyageTabMenu = data.voyageTab
    state.voyage.vslVoyageDisplayVoyageReviewTab = data.displayVoyageReviewTab
    if (data.vesNo) {
      state.vslVoyageVesNo = data.vesNo
    }
  }
}

const actions = {
  async vesselManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.vslManagement
    commit(VESSEL_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }

      let apiURL = commitResult.menu.vesselList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VESSEL_DETAILLIST, result.data.data.vesselList)
        } catch (err) {
          throw err
        }
      }

      apiURL = commitResult.menu.classList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VESSEL_CLASSLIST, result.data.data.classList)
        } catch (err) {
          throw err
        }
      }

      apiURL = commitResult.menu.constnList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VESSEL_CONSTNLIST, result.data.data.constnList)
        } catch (err) {
          throw err
        }
      }

      apiURL = commitResult.menu.engMakeList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VESSEL_ENGMAKELIST, result.data.data.engMakeList)
        } catch (err) {
          throw err
        }
      }

      apiURL = commitResult.menu.engModList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VESSEL_ENGMODLIST, result.data.data.engModList)
        } catch (err) {
          throw err
        }
      }

      apiURL = commitResult.menu.flagList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VESSEL_FLAGLIST, result.data.data.flagList)
        } catch (err) {
          throw err
        }
      }

      apiURL = commitResult.menu.typeList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VESSEL_TYPELIST, result.data.data.typeList)
        } catch (err) {
          throw err
        }
      }

      commit(VESSEL_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(VESSEL_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
